@if (note(); as note) {
  @if (mini()) {
    <div class="px-8">
      <div class="d-flex align-items-center justify-content-between gap-8">
        <h5 class="mb-0">
          {{ note.title }}
        </h5>
        <div class="d-flex align-items-center gap-8">
          <app-btn type="clear" customIcon="fa fa-expand" [mini]="true" (mclick)="expand.emit(note)" />
          <app-btn type="clear" customIcon="fa fa-close" [mini]="true" (mclick)="done.emit(note)" />
        </div>
      </div>
    </div>
  } @else {
    @if (isMatModal()) {
      <modal-header [dialogRef]="dialogRef" [header]="header()" />
    }
    <h4>
      {{ note.title }}
    </h4>
    <div class="time">
      <strong>Time:</strong>
      {{ note.eventOn | date: 'MMM d, yyyy h:mm a' }}
    </div>
  }
  <!-- <div class="note px-8" [class.mini]="mini()" [innerHTML]="noteNote()"></div> -->
  <div class="note" [class.px-8]="mini()" [class.mini]="mini()" [innerHTML]="note.note"></div>
  @if (link()) {
    <div class="d-flex align-items-center gap-8">
      <strong>Meeting Link:</strong>
      <a [href]="link()" target="_blank">
        {{ link() }}
      </a>
    </div>
  } @else if (note.eventPlace) {
    <div>
      <strong>Meeting Place:</strong>
      {{ note.eventPlace }}
    </div>
  }
  @if (!mini()) {
    <div class="colorCode mt-8" [style.background-color]="userCalendarHelperService.typeToColour[note.eventType]"></div>
  }
}
